import removeEmpty from '@src/global-locales/utils/remove-empty.js';
import _ from 'lodash';

let localesData;

/**
 * 与 window 中的 翻译json数据合并
 * @param originData
 * @param ignoreCache
 * @returns {pageLocalesData}
 */
const mergeLocalesData = (originData, ignoreCache) => {
  // TODO TEST
  // return originData;

  // 如果有缓存的话, 返回上一次的值
  if (!localesData || ignoreCache) {
    if (window['$$XFE_LOCALES']) {
      localesData = _.merge(originData, removeEmpty(window['$$XFE_LOCALES']));
    } else {
      return originData;
    }

    // localesData = _.merge(originData, removeEmpty(window['$$XFE_LOCALES'] || {}));
  }
  return localesData;
};

export default mergeLocalesData;
